import { FILTER_TYPES, LANGUAGES } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { Select } from 'foundations-components/components/Select';
import { FiltersWrapper } from './FiltersWrapper';
import I18n from 'I18n';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { jsx as _jsx } from "react/jsx-runtime";
const getOptions = () => LANGUAGES.map(language => ({
  text: LanguageNames[language.toLowerCase()],
  value: language
}));
export const LanguageFilter = ({
  appearsIn
}) => {
  const [language, setLanguage] = useSearchParam(FILTER_TYPES.LANGUAGE);
  const handleLanguageChange = selectedLanguages => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: selectedLanguages.length ? 'filter-selected' : 'filter-deselected',
      value: selectedLanguages,
      isDropdown: true,
      key: 'language-filter',
      appearsIn
    });
    setLanguage(selectedLanguages);
  };
  return /*#__PURE__*/_jsx(FiltersWrapper, {
    children: /*#__PURE__*/_jsx(Select, {
      "aria-label": I18n.text('learningCenter.topFilters.language.filterTitle'),
      clearable: true,
      menuInlineSize: 200,
      menuMaxBlockSize: 400,
      multi: false,
      onSelectedOptionChange: evt => {
        handleLanguageChange(evt.selectedValues);
      },
      options: getOptions(),
      selectedItemsPlaceholder: I18n.text('learningCenter.topFilters.language.filterTitle'),
      selectedValues: language
    })
  });
};